import { Component, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'pz-card',
    templateUrl: 'pz-card.component.html',
    styleUrls: ['pz-card.component.scss']
})

export class PzCardComponent {
    @Input() nzTitle: string | TemplateRef<void>;
    @Input() nzExtra: string | TemplateRef<void>;

}
